import {Injectable} from '@angular/core';
import {ListItem} from './model/list-item';
import {categoryMap, ItemCategory, overig} from './model/item-category';
import {IngredientService} from './ingredient.service';

@Injectable({
  providedIn: 'root'
})
export class ParseService {

  readonly PATTERN: RegExp = /^(.*?)(?:(\d+)\s*(.*?))?$/;

  constructor(private ingredientService: IngredientService) {
  }

  parse(line: string): ListItem | null {
    const trimmedLine = line.trim();
    if (!trimmedLine) {
      return null;
    }

    const result = trimmedLine.match(this.PATTERN);
    if (result) {

      const ingredientName = result[0].trim();
      const shortName = result[1].trim();
      return {
        name: ingredientName,
        shortName,
        collected: 0,
        amount: this.getAmount(result),
        category: this.findCategory(shortName),
      };
    }

    return null;
  }

  private getAmount(result: RegExpMatchArray): number {
    if (result[2] && !result[3]) {
      return parseInt(result[2], 10);
    }

    return 1;
  }

  private findCategory(ingredientName: string): ItemCategory {
    const match = this.ingredientService.find(ingredientName);
    return match ? categoryMap[match.type] : overig;
  }
}
